








import YellowButton from '@/views/atoms/YellowButton.vue'

export default
  name: 'CartButtonArea'

  components: {
    YellowButton
  }

  props:
    button_label:
      type: String
      default: ''

  methods: {
    go_click: (e) ->
      @.$emit('click', e)
  }
